import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import './index.css';
import Error from './Error';
import MainScreen from './Components/MainScreen';
import MovieWatchScreen from './Components/MovieWatchScreen';
import VideoPlayer from './Components/VideoPlayer';
import Seasons from './Components/seriesComponents/Seasons';
import WatchSeason from './Components/seriesComponents/WatchSeason';
import SeriesPlayer from './Components/seriesComponents/SeriesPlayer';

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <Error />,
        children: [
            { path: '', element: <MainScreen /> },
            { path: 'watch/tv/:watchId/season/:season/episode/:episode', element: <SeriesPlayer /> },

            { path: 'watch/tv/:watchId/season/:season', element: <WatchSeason /> },

            { path: 'watch/tv/:watchId', element: <Seasons /> },

            { path: 'watch/movie/:watchId', element: <MovieWatchScreen /> },

            { path: 'video', element: <VideoPlayer /> },
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')).render(<RouterProvider router={router} />);
